import { render, staticRenderFns } from "./KnMenu.vue?vue&type=template&id=fe06855a&"
import script from "./KnMenu.vue?vue&type=script&lang=js&"
export * from "./KnMenu.vue?vue&type=script&lang=js&"
import style0 from "./KnMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports